// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"8ac15aca","453":"6b263a97","699":"7c963cdb"}[chunkId] + ".chunk.js";
};